import { render, staticRenderFns } from "./ArticlesCard.vue?vue&type=template&id=18d4272e&scoped=true&"
import script from "./ArticlesCard.vue?vue&type=script&lang=js&"
export * from "./ArticlesCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesCard.vue?vue&type=style&index=0&id=18d4272e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d4272e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
